import { api } from "./api";
import URI from "./URI";

const hvGetOptions = {
    method: "GET",
    tokenRequired: true, 
}

const hvPostOptions = {
    method: "POST",
    tokenRequired: true, 
}

const responseHandler = async(response) => {
  if(!response.ok) {
    const error = await response.json()
    throw error.error
  }
  return response
}


export const hvGetToken = () => {
    return api(URI.hvGetToken, hvGetOptions, import.meta.env.VITE_BFF_API_BASE);
};

export const hvUpdateEmail = () => {
    return api(URI.hvUpdateEmail, {
        ...hvPostOptions,
        responseHandler
    }, import.meta.env.VITE_PSVC_API_BASE);
};

export const hvUpdatePhone = () => {
    return api(URI.hvUpdatePhone,{
        ...hvPostOptions,
        responseHandler
    }, import.meta.env.VITE_PSVC_API_BASE);
};

export const hvUpdateBank = () => {
    return api(URI.hvUpdateBank, hvPostOptions, import.meta.env.VITE_PSVC_API_BASE);
};

export const hvUpdateSegment = () => {
    return api(URI.hvUpdateSegment, hvPostOptions, import.meta.env.VITE_PSVC_API_BASE);
};